import IdeaIconAndName from './IdeaIconAndName';
import { PLY_IDEA_PREFIX, PLY_IDEA_SUFFIX } from './inspiration-center.const';

// PRIVATE
const REGEX_TO_CHECK = /(\[.*?\])/;

const divideContentToHtmlParts = (formattedContent) => {
	const parts = formattedContent.split(REGEX_TO_CHECK);
	let res = [];
	parts.forEach((part) => {
		if (part.includes(PLY_IDEA_PREFIX, PLY_IDEA_SUFFIX)) {
			res = [
				...res,
				{ component: IdeaIconAndName, props: { serviceId: Number(part.replaceAll(PLY_IDEA_PREFIX, '').replaceAll(PLY_IDEA_SUFFIX, '')) } },
			];
		} else {
			res = [...res, { text: part }];
		}
	});
	return res;
};

const findSquareBracketsThatContainsWordInsideAndReplaceTheWord = (content, params, userFavoritePlyServicesIds) =>
	content.replace(/\[(.*?)\]/g, (match, wordInsideBrackets) =>
		replaceKeyWithServiceDetails(wordInsideBrackets, params, userFavoritePlyServicesIds)
	);

const replaceKeyWithServiceDetails = (wordInsideBrackets, params, userFavoritePlyServicesIds = []) => {
	const paramDetails = params.find((param) => param.key === wordInsideBrackets);
	const isWordAKnownParam = !!paramDetails;
	if (!isWordAKnownParam) {
		return `${wordInsideBrackets}`;
	}
	const relevantUserFavoritePlyServicesIds = paramDetails.related_services.filter((id) => userFavoritePlyServicesIds.includes(id));
	if (relevantUserFavoritePlyServicesIds.length > 0) {
		let replacedString = '';
		relevantUserFavoritePlyServicesIds.forEach((id, i) => {
			replacedString += `${PLY_IDEA_PREFIX}${id}${PLY_IDEA_SUFFIX}`;
			if (i < relevantUserFavoritePlyServicesIds.length - 1) {
				// add slash if not last
				replacedString += '<span class="mx-1">/</span>';
			}
		});
		return replacedString;
	} else {
		return `${paramDetails.default_value}`;
	}
};

// PUBLIC
const formatContentWithServiceDetails = (content, params, userFavoritePlyServicesIds) =>
	divideContentToHtmlParts(
		findSquareBracketsThatContainsWordInsideAndReplaceTheWord(
			content.replaceAll('<p>', '').replaceAll('</p>', '<br />'), // remove <p> and </p> and replace with <br />
			params,
			userFavoritePlyServicesIds
		)
	);

const isIdeaSavedToAccount = (idea) => !!idea.account_idea;
const isIdeaArchived = (idea) => isIdeaSavedToAccount(idea) && idea.account_idea.archived;

const InspirationCenterService = {
	formatContentWithServiceDetails,
	isIdeaSavedToAccount,
	isIdeaArchived,
};

export default InspirationCenterService;
